import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';

// Built from what the site actually has: two short link groups and the data sources.
const GROUPS: Array<[string, Array<[string, string]>]> = [
  ['Look up rents', [['/states', 'Rents by state'], ['/cities', 'Cities'], ['/map', 'Map'], ['/glossary', 'Glossary']]],
  ['fmr8', [['/pricing', 'Pricing'], ['/chrome-extension', 'Chrome extension'], ['/reports', 'Reports'], ['/about', 'About'],
    ['/methodology', 'Methodology'], ['/privacy', 'Privacy'], ['/terms', 'Terms']]],
];

const Footer: React.FC = () => (
  <Box component="footer" sx={{ borderTop: `1px solid ${tokens.line}`, mt: 8 }}>
    <Box sx={{ maxWidth: tokens.container, mx: 'auto', px: { xs: 2, md: 3 }, py: 4, display: 'grid', gap: 4, gridTemplateColumns: { xs: '1fr 1fr', md: '2fr 1fr 1fr' } }}>
      <Box sx={{ gridColumn: { xs: '1 / -1', md: 'auto' }, maxWidth: '60ch' }}>
        <Box sx={{ fontWeight: 800, fontSize: 18, letterSpacing: '-0.02em', mb: 1 }}>fmr<Box component="span" sx={{ color: tokens.signal }}>8</Box></Box>
        <Typography variant="caption" component="p">
          Fair Market Rents from HUD, payment standards from local housing authorities, sales and listings from public
          real estate data, demographics from the Census ACS. Estimates only; confirm rents with the housing authority before you buy.
        </Typography>
      </Box>
      {GROUPS.map(([title, links]) => (
        <Box key={title}>
          <Typography variant="overline" component="p" sx={{ color: tokens.muted, mb: 0.5 }}>{title}</Typography>
          {links.map(([to, label]) => (
            <Box key={to} component={RouterLink} to={to}
              sx={{ display: 'block', py: 0.4, fontSize: 14, color: tokens.ink, textDecoration: 'none', '&:hover': { color: tokens.signal } }}>
              {label}
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  </Box>
);

export default Footer;
